import { inject, Injectable } from '@angular/core';
import {
  ApiDataAccess,
  Dictionary,
  ReadonlyHttpApiListRepository,
  Result,
} from '@softline/core';
import { SOFTLINE_API_DFH_DATA_CARRIER_SUPPLIER } from '../bauprofi.api';
import { SupplierConfig } from '../types/supplier-config';

export interface BauprofiSupplierConfigQuery {
  supplierId: string | undefined;
}

@Injectable()
export class BauprofiSupplierConfigRepository extends ReadonlyHttpApiListRepository<
  Result<SupplierConfig[]>,
  BauprofiSupplierConfigQuery
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_DFH_DATA_CARRIER_SUPPLIER);
  }

  override getLoadPathParams(params: BauprofiSupplierConfigQuery): Dictionary<unknown> {
    return {
      supplierId: params.supplierId,
    };
  }
}
